export const datagk={
	"dlrsarr":[23,116,131,15,101,120,112,129,138,122,41,18,33,107,83,141,92,17,67,9,123,68,77,130,125,105,117,75,57,130,137,129,134,72,139,45,36,88,56,76,117,108,100,111,123,70,82,104,56,115,100,81,77,135,161,155,97,105,102],
	"dlcsarr":[112,91,260,208,245,205,158,134,224,341,69,119,186,269,220,81,156,98,215,54,199,117,194,206,131,209,219,192,148,339,294,301,285,261,215,146,177,148,119,139,180,193,124,135,228,167,159,309,125,241,158,138,119,205,267,221,171,156],
	"ljdlarr":[],
	'ljbgarr':[],
	"tlscarr":[39,13,22,36,28,20,21,24,28,35,33,37,21,17,16,27,33,28,40,35,12,12,17,36,29,18,27,35,25,9,17,41,10,15,39,24,34,28,29,16,38,18,35,28,28,13,31,19,26,21,22,19,16,30,13,19,23,25,24],
	"bgscslarr":[14,10,11,17,12,12,8,19,24,14,17,9,17,19,12,9,15,17,9,17,12,13,14,8,17,16,27,16,17,27,9,22,24,20,20,29,32,31,18,17,15,18,16,17,18,16,26,21,23,29,16,21,33,20,24,30,28,47,30],
	"zlddlcsarr":[1278,1342,1023,1268,1842,1102,1246,1349],
	"zlddlrsarr":[206,195,177,232,266,176,215,275],
	"zltlscarr":[26,28,27,25,22,27,22,20],
	"zlbgscslarr":[84,121,91,109,140,160,114,173],
	"zldatearr":["10/12-10/18","10/19-10/25","10/26-11/01","11/02-11/08","11/09-11/15","11/16-11/22","11/23-11/29","11/30-12/06"],
	"yldatearr":["2020-10","2020-11"],
	"ylddlcsarr":[3444,5898],
	"ylddlrsarr":[358,646],
	"yltlscarr":[24,37],
	"ylbgscslarr":[284,588],
	
}



// WEBPACK FOOTER //
// ./src/assets/js/sygk.js